
import { VariantDisplayOptions } from '@/models/Variant';
import { CbxVariablesModule } from '@/store/modules/CbxVariablesModule';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProductSearchResultProduct } from '../../models/Product';
import ProductDetailsModule from '../../store/modules/ProductDetailsModule';
import AddToCartButton from '../AddToCartButton.vue';
import DetailsAddToWishList from './DetailsAddToWishList.vue';

@Component({
    name: 'DetailsAddToCart',
    components: {
        AddToCartButton,
        DetailsAddToWishList
    }
})
export default class DetailsAddToCart extends Vue {

    @Prop({ type: Number, required: false, default: null }) private quantity: number;
    @Prop({ type: Boolean, required: false, default: false }) private enableBulkOrdering: boolean;

    get displayWishListButton(): boolean {
        return CbxVariablesModule.VARIABLES.enableWishList;
    }

    get product(): ProductSearchResultProduct {
        return ProductDetailsModule.PRODUCT;
    }
    
    get sku(): string {
        if (ProductDetailsModule.VARIANTS?.length > 0) {
            return ProductDetailsModule.SELECTED_VARIANT?.sku;
        }
        return this.product?.id;
    }

    get allowpurchase(): boolean {
        if (ProductDetailsModule.VARIANTS?.length > 0) {
            return ProductDetailsModule.SELECTED_VARIANT?.allowpurchase;
        }
        return this.product?.allowpurchase;        
    }

    get unit(): string {
        if (ProductDetailsModule.VARIANTS?.length > 0) {
            return ProductDetailsModule.SELECTED_VARIANT?.unit;
        }
        return this.product?.unit;
    }

    get colli(): number {
        if (ProductDetailsModule.VARIANTS?.length > 0) {
            return ProductDetailsModule.SELECTED_VARIANT?.colli;
        }
        return this.product?.colli;
    }    
    
    get colliUnit(): string {
        if (ProductDetailsModule.VARIANTS?.length > 0) {
            return ProductDetailsModule.SELECTED_VARIANT?.colliunit;
        }
        return this.product?.colliunit;
    }

    get qty(): number {
        if (this.quantity != null)
            return this.quantity;
            
        return this.colli || 1;
    }

    get dimension1(): string {
        return ProductDetailsModule.SELECTED_VARIANT?.dimension1code ?? '';
    }
    get dimension2(): string {
        return ProductDetailsModule.SELECTED_VARIANT?.dimensioncount === 2
            ? ProductDetailsModule.SELECTED_VARIANT?.dimension2code
            : '';
    }

    get displayOptions(): VariantDisplayOptions {
        return CbxVariablesModule.VARIABLES.variantDisplayOptions;
    }

}
